"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let DownloadTipDialog = class extends Vue {
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  startInstall() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/update/tasks`, {
          url: this.downloadUrl
        });
        yield API.post(`api://base.local/websockets/view`, {
          "model": "pageEvent.start.install"
        });
        this._download_tip_dialog.hide();
      } catch (error) {
        console.log(error);
      }
    });
  }
  open() {
    this._download_tip_dialog.show();
  }
  closeUpdate() {
    this._download_tip_dialog.hide();
    sessionStorage.setItem("updata_message_notify", "show");
  }
};
__decorateClass([
  PropSync("downloadtip", {
    default: function() {
      return "";
    }
  })
], DownloadTipDialog.prototype, "downloadTip", 2);
__decorateClass([
  PropSync("downloadurl", {
    default: function() {
      return "";
    }
  })
], DownloadTipDialog.prototype, "downloadUrl", 2);
__decorateClass([
  PropSync("downloadversion", {
    default: function() {
      return "";
    }
  })
], DownloadTipDialog.prototype, "downloadVersion", 2);
__decorateClass([
  Ref("download-tip-dialog")
], DownloadTipDialog.prototype, "_download_tip_dialog", 2);
DownloadTipDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], DownloadTipDialog);
export {
  DownloadTipDialog as default
};
